var _defs, _path, _path2, _path3, _polygon, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _polygon3, _path25, _rect, _rect2, _path26, _ellipse, _circle, _circle2, _line, _path27, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformacionpersonalCenfotec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    "data-name": "Layer 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 401.46 597.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4d4d4d;}.cls-2{fill:#ffeab9;}.cls-3{fill:#ebf6fc;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:#d1d4d4;}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:#9cc8ff;}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:#4296cf;stroke:#4296cf;}.cls-10,.cls-11,.cls-16,.cls-20,.cls-9{stroke-miterlimit:10;}.cls-10,.cls-11,.cls-12{fill:#ffe28e;}.cls-10{stroke:#ffeab9;}.cls-11{stroke:#ffe28e;}.cls-13{fill:url(#linear-gradient-4);}.cls-14{fill:url(#radial-gradient);}.cls-15{fill:url(#linear-gradient-5);}.cls-16{fill:#deb87d;stroke:#deb87d;}.cls-17{fill:url(#linear-gradient-6);}.cls-18{fill:#00479b;}.cls-19{fill:#006aea;}.cls-20{fill:none;stroke:#00479b;}.cls-21{fill:#f2f2f2;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 921.64,
    y1: 311.05,
    x2: 871.27,
    y2: 311.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#b9d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a4ccff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#a0caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#add2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c3ddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfe4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 881.79,
    y1: 487.37,
    x2: 952.12,
    y2: 487.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e2e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#d5d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1d4d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 984.86,
    y1: 328.63,
    x2: 905.68,
    y2: 325.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 874.47,
    y1: 623.43,
    x2: 925.58,
    y2: 623.43,
    gradientTransform: "matrix(1, 0.07, -0.07, 1, 29.57, -61.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#75a6e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#235fa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03438f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 940.88,
    cy: 243.67,
    fx: 954.360758947321,
    fy: 257.2883637414503,
    r: 19.16,
    gradientTransform: "matrix(-0.82, 0.01, 0.01, 0.86, 1709.7, 57.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8c79e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1028.14,
    y1: 625.36,
    x2: 1069.55,
    y2: 625.36,
    gradientTransform: "matrix(-0.77, -0.63, -0.63, 0.77, 2177.93, 812.36)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1015.71,
    y1: 323.35,
    x2: 948.29,
    y2: 317.52,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M910.61,207.22c5-13.85,16.49-23.22,28.91-23.81,14.91-.71,25,11.51,26.09,12.92,8.48,10.64,4.41,19.36,9.1,47,2.22,13,2.92,9.88,6.72,28.23,3,14.27,6.62,32.36,6.65,54.49,0,22.62.06,33.92-7.17,40.16-9.57,8.24-24.92,5.73-50.84,1.49-14.18-2.32-21.34-3.59-25.13-8.74-6.24-8.5,2.24-16.44,2.11-38.91-.09-16.12-4.49-18.62-4.63-34.8a94.24,94.24,0,0,1,6.06-33.72Z",
    transform: "translate(-597.76 -47.48)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M900.16,365.68c-3.33,8-7,6.61-10.79.95-.2-2.65-.57-6.93-1.24-12.23-.93-7.41-1.43-8.69-1.89-14-.16-1.81-.08-1.48-.48-14.06-.25-7.9-.32-9.55-.37-13.34,0-4.22,0-7.7,0-10.09l22.31.56c0,1.87-.11,4.72-.19,8.19-.19,9.48-.14,10.59-.31,13.58a114.6,114.6,0,0,1-1.64,13.88c-1.2,6.57-2.11,8-3.59,15.3C901,359.25,900.45,363.22,900.16,365.68Z",
    transform: "translate(-597.76 -47.48)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M984.14,385.91h.12a6.89,6.89,0,0,0,7.64-5.57c.25-1.73.54-3.65.89-5.73,1.23-7.24,1.83-8.48,2.47-13.7.21-1.77.12-1.45.82-13.76.44-7.72.56-9.34.69-13.05,0-1.16.07-2.27.1-3.32.09-3.6-3.07-6.55-7-6.54l-11.76,0c-3.87,0-7,2.9-7,6.45,0,.51,0,1,0,1.6.05,9.28,0,10.36.1,13.29a95,95,0,0,0,1.64,13.63c1.26,6.46,2.29,7.9,3.87,15.06.5,2.3.89,4.39,1.19,6.21A6.74,6.74,0,0,0,984.14,385.91Z",
    transform: "translate(-597.76 -47.48)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "305.22 298.99 290.82 299.54 292.18 228.61 306.57 228.06 305.22 298.99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M903.28,346.77c-4.86.25-9.79.49-14.68.68h-.25l-.19-.44a69.21,69.21,0,0,1-3-8.93c-.83-3-1.51-5.94-2.07-8.91a142.74,142.74,0,0,1-2.29-17.78c-.2-3-.34-5.92-.38-8.88,0-1.48,0-3,0-4.44s0-2.95.15-4.43a27,27,0,0,1,2.41-8.82,27.6,27.6,0,0,1,2.6-4.39,23.61,23.61,0,0,1,4-4.36l.41-.41,14.39-.56.44.44a31,31,0,0,1,8.88,5,20.1,20.1,0,0,1,4.75,5.38,13.09,13.09,0,0,1,1.89,8l-.15,2.6a126.12,126.12,0,0,1-2.93,20.12,96.23,96.23,0,0,1-5.74,17.54,56.32,56.32,0,0,1-3.76,7.11A23.38,23.38,0,0,1,903.28,346.77Zm-.61-.6c-1.56-4.52-2.82-8.5-4.07-12.3l-3.42-10.62c-2.09-6.65-3.81-12.5-5.06-17.93A86,86,0,0,1,887.86,290l-.06-1.84a6.84,6.84,0,0,1,.11-1.81,7.09,7.09,0,0,1,2-3.46,20.12,20.12,0,0,1,4.91-3.49,55.3,55.3,0,0,1,9-3.85l.44.43-14.4.56.41-.42a23.89,23.89,0,0,1,3.83,4.51,27.74,27.74,0,0,1,2.42,4.48,26.81,26.81,0,0,1,2.07,8.91c.1,1.48,0,3,0,4.43s-.11,3-.19,4.43c-.16,3-.41,5.91-.72,8.86a142.45,142.45,0,0,1-3,17.68q-1,4.43-2.41,8.83A70.5,70.5,0,0,1,889,347l-.44-.43C893.27,346.41,897.94,346.28,902.67,346.17Z",
    transform: "translate(-597.76 -47.48)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M931.64,361.68l22.6-1.22-7.41,49.69-9.67,5.29Z",
    transform: "translate(-597.76 -47.48)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M931.34,361.42c7.59-.48,15.25-.95,22.88-1.35l.24,0,.18.47,19.89,53.76,4.15,11.21-18.41,9.23-9.87,4.94-52.92,26.53,12.22-47.93c1.62-6.37,3.43-12.47,5.36-18.16s4-11,6-15.71,4-9,5.72-12.81S930.06,364.45,931.34,361.42Zm.6.52a149.28,149.28,0,0,0,7.35,16.72,125.84,125.84,0,0,0,8.47,14.07,129.75,129.75,0,0,0,8.73,11.17c2.85,3.28,5.58,6.13,8.13,8.73l-40.71-21.4,9.49-5.64L919.14,406l34.71-45.62.42.46C946.83,361.26,939.42,361.61,931.94,361.94Z",
    transform: "translate(-597.76 -47.48)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M894.78,596.77l24.36,2.58,19.27-223.79-16,7.21q-10,58.78-18,122.55Q898.67,552.2,894.78,596.77Z",
    transform: "translate(-597.76 -47.48)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M895,596.58l24.15,2.58-.21.17c.84-9.32,1.57-18.65,2.33-28s1.44-18.66,1.9-28c1-18.7.87-37.5,1.1-56.27s1-37.49,2.7-56.13a100.5,100.5,0,0,1,2.57-13.86c.58-2.3,1.24-4.59,1.91-6.89l2-6.87a117.88,117.88,0,0,0,3.17-13.82c.76-4.63,1.07-9.3,1.56-13.95l.31.22q-8.06,3.51-16.08,7.09l.05-.07q-2.31,13.29-4.26,26.64l-1,6.67a32.39,32.39,0,0,0-.44,6.76,35.17,35.17,0,0,0,1.07,7c.62,2.37,1.38,4.75,2.19,7.14s1.57,4.77,2.18,7.12a35.7,35.7,0,0,1,1.06,7,32.75,32.75,0,0,1-.46,6.72l-1,6.64q-2,13.29-4.11,26.55c-2.88,17.69-6.08,35.35-9.73,53-1.8,8.82-3.78,17.63-5.86,26.45L900.54,577l-1.7,6.6c-.59,2.2-1.17,4.41-1.8,6.61a30.93,30.93,0,0,1-1,3C895.72,594.19,895.32,595.33,895,596.58Zm-.47.39-.46-3.34c-.16-1.21-.26-2.68-.36-3.73-.22-2.28-.4-4.55-.57-6.83-.33-4.55-.56-9.1-.74-13.64-.33-9.09-.45-18.16-.31-27.22.22-18.12,1.28-36.19,3-54.18q1.3-13.48,3.06-26.93l.92-6.71a32.71,32.71,0,0,1,1.45-6.64,35.32,35.32,0,0,1,3-6.4c1.26-2.1,2.68-4.17,4.15-6.23s2.92-4.11,4.2-6.19a37.36,37.36,0,0,0,3.13-6.35,34.78,34.78,0,0,0,1.63-6.58l1.13-6.65,4.51-26.6v-.05l.05,0q8-3.63,16-7.33l.34-.16,0,.39c-.32,4.67-.81,9.32-.85,14a118.29,118.29,0,0,0,.75,14.16l.8,7.11c.27,2.37.52,4.75.71,7.11a102.2,102.2,0,0,1,.16,14.1c-1.47,18.66-3.91,37.24-6.94,55.77s-6.29,37-8.54,55.63q-1.71,13.93-2.91,27.93c-.85,9.32-1.72,18.63-2.49,28l0,.19-.19,0Z",
    transform: "translate(-597.76 -47.48)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M922.92,376.21l38.9,2.56L967,298c-2.2-.34-5.27-.75-9-1-3.27-.24-5.82-.3-10.06-.38-5.79-.12-6.25,0-9.33-.13a103.76,103.76,0,0,1-10.56-1Z",
    transform: "translate(-597.76 -47.48)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M923.11,376l19.33,1.31c6.46.44,12.94.8,19.4,1.2l-.24.2c.18-3.37.43-6.73.52-10.1a88.76,88.76,0,0,0-.33-10.17,115,115,0,0,0-4-20.53c-1.9-6.88-4.1-13.78-5.81-20.65a127.75,127.75,0,0,1-3.51-20.51l15.63,19.46c-1.39.08-2.78.18-4.15.23-.68,0-1.37.06-2,.06s-1.33,0-2.09.09c-2.93.24-5.8.35-8.74.33-1.55,0-3,0-4.5,0l-1.3,0-1.57-.07c-1.1-.06-2.07-.14-3-.25a76.46,76.46,0,0,1-11.46-2.14l22-17.8c-.65,2.77-1.3,5.56-2.1,8.39s-1.56,5.68-2.46,8.6c-1.73,5.82-3.75,11.89-5.87,18.32s-4.41,13.27-6.7,20.58S925.53,367.58,923.11,376Zm-.39.34c-1.55-5-3-10.74-4.44-16.88s-2.87-12.79-4.13-19.83-2.41-14.43-3.29-22.07c-.47-3.81-.84-7.69-1.18-11.6s-.59-7.85-.81-11.81l-1-17.54,23-.26q4.07-.06,8-.19l1.83-.06.88,0,1.13,0c1.72,0,3.55,0,5.25.07,3.57.19,7.2.58,10.76,1.06.88.09,1.85.34,2.78.53s1.86.41,2.79.62c1.86.42,3.71.89,5.55,1.34l18.83,4.64-3.2,14.81a126.87,126.87,0,0,1-6.08,19.9c-2.57,6.6-5.63,13.16-8.38,19.75a113.86,113.86,0,0,0-6.53,19.86,88.88,88.88,0,0,0-1.62,10c-.34,3.36-.52,6.73-.76,10.09l0,.23-.22,0c-6.51-.46-13-.95-19.51-1.36Z",
    transform: "translate(-597.76 -47.48)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M936.59,300.78",
    transform: "translate(-597.76 -47.48)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "392.1 553.18 367.93 556.76 339.39 339.53 363.57 335.95 392.1 553.18"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M990.13,600.86l-24.39,3.71-.3,0-.08-.33c-2.22-8.92-4.21-17.87-6.08-26.83s-3.64-17.94-5.32-26.92q-5-27-9.17-54c-2.79-18.05-5.36-36.13-7.6-54.25-1-9.07-1.65-18.2-1.81-27.38q-.14-6.89.17-13.84a130.86,130.86,0,0,1,1.27-14l0-.35.23,0,24.18-3.58h.1l.28.3a58.72,58.72,0,0,1,8.85,13,87.44,87.44,0,0,1,5.64,13.77,102.48,102.48,0,0,1,3.41,14.12c.79,4.74,1.25,9.47,1.85,14.21,2.22,18.94,4,37.88,5.37,56.53s2.3,37,2.87,54.78c.25,8.87.5,17.64.58,26.17S990.37,592.88,990.13,600.86Zm-.54-.4c-2.61-10.11-4.93-19.82-7.23-29.39s-4.43-18.91-6.55-28.14c-4.19-18.44-8-36.28-11.4-53.83s-6.36-34.82-8.9-52.09c-.59-4.31-1.32-8.63-1.71-12.94a82.08,82.08,0,0,1-.16-13,76.22,76.22,0,0,1,2.07-13.39A61.7,61.7,0,0,1,961,383.48l.38.28-24.18,3.58.28-.37a128.21,128.21,0,0,1,4.84,13.17q2.08,6.63,3.73,13.32c2.23,8.92,4,17.9,5.34,26.93q3.75,27.12,6.66,54.37t5.09,54.57Q964.21,563,965,576.72c.51,9.14.89,18.29,1.06,27.48l-.38-.29Z",
    transform: "translate(-597.76 -47.48)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M870.56,257",
    transform: "translate(-597.76 -47.48)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M853.5,240.33",
    transform: "translate(-597.76 -47.48)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M969,341.73",
    transform: "translate(-597.76 -47.48)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M909.3,275.64",
    transform: "translate(-597.76 -47.48)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M878.7,256",
    transform: "translate(-597.76 -47.48)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M867.53,621.72c-5.78,7.6-8.67,11.4-7.12,13.88,3.69,5.89,28.45,3.27,43.33-9,3.67-3,10.11-8.34,8.54-14.32-1.65-6.3-11.53-10.93-19.39-10.79C882.77,601.67,876.62,609.76,867.53,621.72Z",
    transform: "translate(-597.76 -47.48)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M922.92,280.11c1.3,6.06,4.42,8.05,5.18,8.49,5.55,3.23,15.37-.23,21.83-10.44a29.46,29.46,0,0,1-2.1-3.71,26.46,26.46,0,0,1-2.38-6.93,46.87,46.87,0,0,1-.58-6.45c-.09-1.85-.12-3.73-.14-4.86,0-1.41,0-2.6,0-3.46l-16,.11c.08.85.17,2,.24,3.46.09,1.72.18,3.35.15,5.09a35.12,35.12,0,0,1-.61,6,3.34,3.34,0,0,1-.07.33,31,31,0,0,1-2.88,7.58C924.91,276.62,924,278.26,922.92,280.11Z",
    transform: "translate(-597.76 -47.48)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M913.59,221.45c.22,7.13.43,12.18,2.86,17.79,2.11,4.85,4.83,7.67,7.48,10.41,4.59,4.75,7.76,8,12.06,8s7.09-3.1,12-8.34c3.17-3.35,6.63-7,8.91-13.39,1.79-5,2-9.21,2.2-14.51.38-8.76.6-14-1.5-19.11-4-9.65-14.06-13.37-21.29-13.38S919,192.7,915,202.35C913.14,206.79,913.29,211.68,913.59,221.45Z",
    transform: "translate(-597.76 -47.48)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M923,184.54A37.51,37.51,0,0,1,941.51,183c13.92,2.49,29.7,14.11,29,27.36-.28,5.06-3,11.08-8,13.85-9.59,5.31-23.46-3.59-31.32-8.64-6.29-4-4.85-4.75-13.32-10.44-3.74-2.51-6.57-4.09-7.21-7.18s1.4-6.25,2.86-8Z",
    transform: "translate(-597.76 -47.48)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M951.49,626.35c-7.64,5.69-11.46,8.54-10.67,11.37,1.87,6.72,26.23,11.25,43.87,3.63,4.36-1.88,12-5.17,12.16-11.38.19-6.54-8-13.82-15.49-15.92C971.65,611.36,963.52,617.41,951.49,626.35Z",
    transform: "translate(-597.76 -47.48)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M858.43,309.94l.06-.06c2-1.8,4.93-1.69,6.32.22s3.23,4.4,5.27,7.07c4.87,6.38,5.93,7.33,9.31,12,1.14,1.6.91,1.33,8.4,12.7,4.71,7.14,5.71,8.62,7.92,12.08,3.38,5.28,3.54,5.54,3.67,5.8.75,1.58,1.33,4.34-.55,9.1l-2.31,1.6c-3.88,1.06-8.84,1.72-11.88-.94-.45-.4-.21-.36-2.52-4.17-5.32-8.8-6-9.8-7.61-12.62-3.64-6.38-6.06-11.6-6.93-13.5-3-6.59-3.24-8.34-6.48-15.71-1.45-3.31-2.8-6.16-3.91-8.4A4.45,4.45,0,0,1,858.43,309.94Z",
    transform: "translate(-597.76 -47.48)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M904,384.54",
    transform: "translate(-597.76 -47.48)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "378.5 314.71 397.85 312.6 389.97 231.27 370.62 233.38 378.5 314.71"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M976.5,361.91c6.38-.77,12.71-1.51,19.07-2.2l-.33.41a99,99,0,0,1-3.79-9.9c-1.1-3.31-2.07-6.64-3-10q-2.61-10-4.26-20.11c-.55-3.37-1.06-6.74-1.47-10.12-.21-1.69-.41-3.39-.58-5.08s-.39-3.38-.44-5.09a39,39,0,0,1,1-10.35,35.77,35.77,0,0,1,1.7-5.3,26.81,26.81,0,0,1,2.93-5.42l.41.34-19.35,2.11.34-.4a39.78,39.78,0,0,1,8.3,3.95,19.37,19.37,0,0,1,4.65,3.89,9.92,9.92,0,0,1,2.12,4.07,10.4,10.4,0,0,1,.28,2.17l.12,2.2a131.25,131.25,0,0,1-.54,18.32c-.6,6.43-1.57,13.29-2.8,20.89-.61,3.81-1.26,7.78-2,12S977.43,357,976.5,361.91Zm-.47.57a40.87,40.87,0,0,1-4.37-6.76c-1.39-2.54-2.69-5.35-4-8.32A150.82,150.82,0,0,1,961,327.63a180.35,180.35,0,0,1-4.47-22.35l-.37-2.88a18.72,18.72,0,0,1-.22-2.91,17.7,17.7,0,0,1,1.14-6.1,21.59,21.59,0,0,1,3.66-6.28A27.44,27.44,0,0,1,968,280.9l.33-.41,19.35-2.11h0l.36.34a26.43,26.43,0,0,1,3.92,4.75,35.08,35.08,0,0,1,2.68,4.88,38.53,38.53,0,0,1,2.95,10c.28,1.69.4,3.38.56,5.08s.28,3.39.4,5.09c.24,3.4.39,6.8.5,10.21q.32,10.24-.33,20.56-.31,5.16-1,10.36A97.24,97.24,0,0,1,996,360.05l-.09.38-.24,0C989.12,361.17,982.54,361.84,976,362.48Z",
    transform: "translate(-597.76 -47.48)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 913.09,
    y: 295.98,
    width: 35.07,
    height: 48.73,
    rx: 7.26,
    transform: "translate(-651.35 275.74) rotate(-19.16)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 916.36,
    y: 297.08,
    width: 33.98,
    height: 47.22,
    rx: 7.35,
    transform: "translate(-641.66 135.5) rotate(-10.94)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M951.1,333.3l.06-.07c1.83-2,4.62-2.41,6-.92s3.24,3.4,5.28,5.45c4.88,4.89,5.93,5.57,9.32,9.21,1.16,1.24.92,1,8.49,10,4.76,5.62,5.76,6.78,8,9.52,1.4,1.7,2.65,3.25,3.72,4.59,1.2,1.51.58,4.08-1.38,5.71L984,382.32c-1.94,1.62-4.46,1.7-5.63.18-.75-1-1.61-2.1-2.56-3.32-5.4-7-6.09-7.78-7.73-10.05a128.65,128.65,0,0,1-7.11-11c-3.11-5.43-3.41-7-6.77-13.06-1.51-2.73-2.91-5.06-4-6.89C949.27,336.86,949.68,334.83,951.1,333.3Z",
    transform: "translate(-597.76 -47.48)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 944.94,
    cy: 323.83,
    rx: 7.39,
    ry: 7.69,
    transform: "translate(-599.97 -40.96) rotate(-0.39)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 346.78,
    cy: 179.82,
    r: 7.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 324.27,
    cy: 178.39,
    r: 7.15
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 331.92,
    y1: 178.39,
    x2: 339.63,
    y2: 178.39
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M838.45,293.2c10.26,8.39,12.06,12.18,16.36,11.94,3.82-.22,8.19-3.53,8.17-6.54-.07-8.1-32-15-33-12.35C829.64,287,831.83,287.79,838.45,293.2Z",
    transform: "translate(-597.76 -47.48)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 240.82,
    height: 223.78,
    rx: 28.86
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 157.73,
    y: 74.66,
    width: 129.87,
    height: 120.68,
    rx: 28.86
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 28.08,
    y: 41.76,
    width: 129.65,
    height: 5.76
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 28.08,
    y: 59.04,
    width: 100.08,
    height: 5.76
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 28.08,
    y: 82.08,
    width: 100.08,
    height: 5.76
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 28.08,
    y: 159.84,
    width: 129.65,
    height: 5.76
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 180.29,
    y: 132.12,
    width: 84.92,
    height: 5.76
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 180.29,
    y: 156.72,
    width: 84.92,
    height: 5.76
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_07",
    "data-name": "icon 07"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 222.94,
    cy: 99.85,
    rx: 9.3,
    ry: 9.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M831.55,170.65a11.13,11.13,0,1,0-22.25,0",
    transform: "translate(-597.76 -47.48)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformacionpersonalCenfotec);
export default __webpack_public_path__ + "static/media/InformacionpersonalCenfotec.1ce9a1e2b539c9ad7f9a9fd7c021145d.svg";
export { ForwardRef as ReactComponent };